import React, { useEffect, useRef, useState } from 'react';
import './SearchDropdown.css';
import { useProductStore } from '../../store/useProductStore';
import { Link, useNavigate } from 'react-router-dom';
import QueryModal from './QueryModal';
import ProductHelpButton from './ProductHelpButton';

const SearchDropdown = ({ open = false, loading = false, setOpen, setSearch, setOpenQueryFormModal }) => {
  const showSearch = open || loading;
  const dropdownRef = useRef(null);
  const { product } = useProductStore();
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    if (showSearch) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showSearch, setOpen]);

  const handleItemClick = (id) => {
    setOpen(false);
    setSearch('');
    navigate(`/product-details/${id}`);
  };

  const handleOpenQueryModal = () => {
    setOpenQueryFormModal(true);
    setOpen(false)
    setSearch('')
  };



  return (
    <div className={`search-dropdown ${showSearch ? 'visible' : ''}`} ref={dropdownRef}>
      <div className="search-results-group">
        <div>
          <h2 id="search-products-title" className="search-heading text-body caption-with-letter-spacing">
            Products
          </h2>
          <ul
            id="search-results-list"
            className="results-list reset-list"
            role="group"
            aria-labelledby="search-products-title"
          >
            {(product || []).map((ele) => (
              <li
                key={ele?._id}
                id={`search-option-${ele?._id}`}
                className="search-item"
                role="option"
                aria-selected="false"
                onClick={() => handleItemClick(ele._id)}
              >
                <div className="search-link link-text" tabIndex="-1">
                  <img
                    className="product-image"
                    src={
                      ele?.images?.[0] && ele.images[0].startsWith("http")
                        ? ele.images[0]
                        : "/fallback-product.png"
                    }
                    alt={ele?.name || "Product Image"}
                    width="50"
                    height="50"
                    loading="lazy"
                    referrerPolicy="no-referrer"
                  />
                  <div className="item-content center-align">
                    <p className="item-title h5">{ele?.name}</p>
                  </div>
                </div>
              </li>
            ))}
          </ul>

          {
            ((product || []).length <= 0) &&
            <div>
              <ProductHelpButton
                handleOpenQueryModal={handleOpenQueryModal}
              />
            </div>
          }
        </div>
      </div>
    </div>
  );
};

export default SearchDropdown;
